<template>
  <div>
    <el-dialog
      @close="close"
      title="配置"
      :visible.sync="openCardDialog"
      width="30%">
      <el-tabs v-model="activeName" >
        <el-tab-pane label="内容模块" name="first">
          <vuedraggable class="content-bottom-vuedraggable" v-model="data">
            <transition-group style="cursor: move;height: 100%">
              <div v-for="(item,index) in data" :key="item.id" class="modular">
                <el-checkbox v-model="item.checked">{{item.name}}</el-checkbox>
                <el-input style="width: 100px" size="mini" v-model="item.width" placeholder="请输入宽度"></el-input>
              </div>
            </transition-group>
          </vuedraggable>
        </el-tab-pane>
        <el-tab-pane label="区域参数" name="second">
          <el-form label-width="70px" :model="regionFrom">
            <el-form-item label="区域高度">
              <el-input size="small" v-model="regionFrom.height"></el-input>
            </el-form-item>
            <el-form-item label="区域边距">
              <el-input size="small" placeholder="10px 20px" v-model="regionFrom.padding"></el-input>
            </el-form-item>
            <el-form-item label="模块间距">
              <el-input size="small" placeholder="10px" v-model="regionFrom.margin"></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="determine">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 拖动
import vuedraggable from 'vuedraggable';
export default {
  name: "functionArea",
  components:{
    vuedraggable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeName: 'first',
      dialogImageUrl: '',
      fileList:'',
      regionFrom: {
        imageUrl:'',
        height:'40%',
        padding:'10px 20px',
        margin:'10px',
      },
      data:[
        {id:1,name:'组织机构',width:'',checked:false},
        {id:2,name:'大事纪要',width:'',checked:false},
        {id:3,name:'应用资源',width:'',checked:false},
        {id:4,name:'简介和视频',width:'',checked:false},
        {id:5,name:'视频轮播',width:'',checked:false}
      ]
    };
  },
  computed: {
    openCardDialog: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods:{
    close() {
      // this.data = [
      //   {id:1,name:'组织机构',input:'',checked:false},
      //   {id:2,name:'大事纪要',input:'',checked:false},
      //   {id:3,name:'应用资源',input:'',checked:false},
      //   {id:4,name:'简介和视频',input:'',checked:false},
      //   {id:5,name:'视频轮播',input:'',checked:false}
      // ]
    },
    // 取消
    cancel() {
      this.$emit('cancel',this.regionFrom)
    },
    // 确定
    determine() {
      // 获取选中的数据
      let dataList = []
      this.data.map((item,index) => {
        if (item.checked) {
          dataList.push(item)
        }
      })
      console.log(this.regionFrom);
      this.$emit('determine',dataList,this.regionFrom)
    }
  }
}
</script>

<style scoped>
.modular {
  padding: 10px;
  border: 1px solid #eaeaea;
  margin-top: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modular:nth-child(1) {
  margin-top: 0;
}
>>> .el-dialog__body {
  padding: 0 20px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/pageConfig/functionArea.vue